// src/sepa.ts
//
// SPAYD (Short Payment Descriptor) – řetězec pro QR platbu podle českého
// standardu. Struktura řetězce se NESMÍ měnit, podle něj banka páruje platby
// (viz docs/redesign-plan.md, krok 6).

/**
 * Odstraní diakritiku: NFD rozklad a vypuštění kombinujících znaků
 * ("Příliš žluťoučký" → "Prilis zlutoucky"). Zpráva pro příjemce v QR platbě
 * musí být bez diakritiky – ne každá banka ji ve zprávě přenese správně.
 */
export const stripDiacritics = (s: string): string =>
  s.normalize("NFD").replace(/[̀-ͯ]/g, "");

export const generateQrPaymentString = (params: {
  iban: string;
  amount: number | string; // povolíme i string
  currency: string;
  msg: string;
  variableSymbol: string;
}): string => {
  const amountNum =
    typeof params.amount === "string"
      ? parseFloat(params.amount)
      : params.amount;
  if (isNaN(amountNum)) {
    throw new Error(`Neplatná částka: ${params.amount}`);
  }
  // Diakritiku ze zprávy odstraňujeme tady, ať na to volající nemusí myslet
  // (dřív to dělala jen přihláška na závod, platba členství ne).
  const msg = stripDiacritics(params.msg);
  return `SPD*1.0*ACC:${params.iban}*AM:${amountNum.toFixed(2)}*CC:${
    params.currency
  }*MSG:${msg}*X-VS:${params.variableSymbol}*`;
};
